import React from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { Element } from "react-scroll";
import styled from "styled-components";

import ComingSoon from "../components/ComingSoon/ComingSoon";
import GlobalStyle from "../components/GlobalStyle";

import bgSrcMobile from "../nmd2025/assets/bg2025_mobile@2x.jpg";
import bgSrcDesktop from "../nmd2025/assets/bg2025@2x.jpg";

import { Counter } from "../nmd2025/Counter/Counter";
import { Header } from "../nmd2025/microsite/Header/Header";
import { Main } from "../nmd2025/microsite/Main/Main";
import { Footer } from "../nmd2025/microsite/Footer/Footer";
import { Recipes } from "../nmd2025/microsite/Recipes/Recipes";
import { Merch } from "../nmd2025/microsite/Merch/Merch";
import CookieDisclaimer from "../nmd2025/CookieDisclaimer/CookieDisclaimer";

import Sweepstakes from "../components/Sweepstakes/Sweepstakes";

import useUTMCookies from "../hooks/useUTMCookies";

const Root = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 375px;
  min-height: 100vh;
  background-color: #171717;
`;

const HomeWrapper = styled.div`
  flex-grow: 1;
  position: relative;
  width: 100%;
  background-repeat: no-repeat;
  background-size: 100%;
  background-position-x: center;

  @media (max-width: 1023px) {
    background-image: url(${bgSrcMobile});
  }

  @media (min-width: 1024px) {
    background-image: url(${bgSrcDesktop});
  }
`;

const IndexPage = () => {
  useUTMCookies();

  return (
    <GoogleReCaptchaProvider reCaptchaKey="6LfaaKwcAAAAAKA_cozC1lBk7DvgVucS97WeS-MY">
      <GlobalStyle />
      <Root>
        {/* process.env.GATSBY_APP_ENV === "master" ? (
          <ComingSoon />
        ) : (
          <>
            <HomeWrapper>
              <Element name="home">
                <Counter />
                <Header />
                <Main />
              </Element>
              <Element name="prizes">
                <Sweepstakes />
              </Element>
              <Element name="cocktails">
                <Recipes />
              </Element>
              <Element name="merch">
                <Merch />
              </Element>
            </HomeWrapper>
            <Footer />
          </>
        ) */}
        <HomeWrapper>
          <Element name="home">
            <Counter />
            <Header />
            <Main />
          </Element>
          <Element name="prizes">
            <Sweepstakes />
          </Element>
          <Element name="cocktails">
            <Recipes />
          </Element>
          <Element name="merch">
            <Merch />
          </Element>
        </HomeWrapper>
        <Footer />
      </Root>
      <CookieDisclaimer />
    </GoogleReCaptchaProvider>
  );
};

export default IndexPage;
